// @mui
import { List, Box } from '@mui/material';
// hooks
import { useAppSelector } from '../../../store/hooks';
import useLocales from '../../../hooks/useLocales';
//
import { NavSectionProps } from '../type';
import { filterNavConfig } from '..';
import { ListSubheaderStyle } from './style';
import NavList from './NavList';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ navConfig, isCollapse, ...other }: NavSectionProps) {
  const { translate } = useLocales();
  const { roles } = useAppSelector((state) => state.auth);

  const filteredConfig = filterNavConfig(navConfig, roles || []);

  return (
    <Box {...other}>
      {filteredConfig.map((group) => {
        const subheaderText = translate(group.subheader);

        return (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {subheaderText}
            </ListSubheaderStyle>

            {group.items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChildren={!!list.children}
                isCollapse={isCollapse}
              />
            ))}
          </List>
        );
      })}
    </Box>
  );
}
